import { render } from "./NotificationFolderListViewEditItemPane.vue?vue&type=template&id=242cdee9&scoped=true&ts=true"
import script from "./NotificationFolderListViewEditItemPane.vue?vue&type=script&lang=ts"
export * from "./NotificationFolderListViewEditItemPane.vue?vue&type=script&lang=ts"

import "./NotificationFolderListViewEditItemPane.vue?vue&type=style&index=0&id=242cdee9&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242cdee9"]])

export default __exports__